import React, { lazy, Suspense } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import useTheme from "@material-ui/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import makeStyles from "@material-ui/styles/makeStyles";
import useLocals from "@micado-digital/react-ui/hooks/useLocals";
import localDE from "../../../locales/de.json";
import localEN from "../../../locales/en.json";

const Button = lazy(() =>
	import(/* webpackChunkName: "reactButton" */ "../../../components/button")
);

const useStyles = makeStyles(theme => ({
	root: {
		"& button": {
			fontSize: 14,
			[theme.breakpoints.up("sm")]: {
				fontSize: 16
			},
			[theme.breakpoints.up("lg")]: {
				fontSize: 23
			}
		}
	}
}));

const Booking = ({ fixed, lang, link, menuOpen, mode, target }) => {
	const css = useStyles();
	const theme = useTheme();
	const bigScreen = useMediaQuery(theme.breakpoints.up("lg"));
	const l = useLocals({
		lang: lang,
		res: {
			de: localDE,
			en: localEN
		}
	});

	return (
		<Box className={clsx("mco-header__booking", css.root)}>
			<Suspense fallback={<></>}>
				<Button
					label={l("header.buttonBooking")}
					color={
						fixed || menuOpen
							? theme.palette.primary.main
							: mode
							? theme.palette.secondary.main
							: "#FFFFFF"
					}
					colorHover={
						fixed || menuOpen ? theme.palette.secondary.main : theme.palette.primary.main
					}
					border={
						fixed || menuOpen ? theme.palette.primary.main : theme.palette.secondary.main
					}
					borderHover={
						fixed || menuOpen ? theme.palette.secondary.main : theme.palette.primary.main
					}
					link={link}
					target={target}
					size={bigScreen ? "medium" : "small"}
				></Button>
			</Suspense>
		</Box>
	);
};

Booking.propTypes = {
	link: PropTypes.string.isRequired
};

export default Booking;
